import { UseUserData } from 'lib/hooks/useUser'
import { Message, Form } from 'semantic-ui-react'

import VehicleFlow from './VehicleFlow'

const Vehicle = ({ user }: { user: UseUserData }) => {
  return (
    <>
      <Message
        attached="top"
        header="Vehicle Recall Tracking"
        content="Get notified when a recall notice applies to your vehicle"
        size="tiny"
      />
      <Form className="attached fluid segment" size="large">
        <VehicleFlow user={user} />
      </Form>
    </>
  )
}

export default Vehicle
